import React from 'react';
import Blog4 from '../../containers/BlogContainers/Blog4';
import PageHeader from '../Shared/PageHeader';

const BlogDetails = () => {
    return (
        <div>
            <PageHeader title="Blog Details" />
            <Blog4 />
        </div>
    );
};

export default BlogDetails;